<template>
  <b-card>
    <b-overlay
      :show="loading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-form
        @submit.prevent="setVolumetricSetting"
      >
        <b-row>
          <b-card title="Volumetric Weight Option">
            <b-form-radio-group
              v-model="form.enabled"
              :options="radioOptions"
              class="demo-inline-spacing mb-1"
              value-field="value"
              text-field="text"
              disabled-field="notEnabled"
            />
          </b-card>
        </b-row>
        <b-row>
          <div class="ml-2">
            Enabling this setting will allow you to see the volumetric weight of your orders. The volumetric
            weight equation is calculated by multiplying the length,
            width, and height of your package. The result will be displayed as the volumetric weight in
            kilograms.
          </div>
        </b-row>
        <b-row>
          <b-col class="d-flex justify-content-end">
            <b-button
              v-can="'business-profile-manage'"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mt-1"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BRow, BForm, BCard, BOverlay, BFormRadioGroup, BButton, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const VolumetricSettingsRepository = RepositoryFactory.get('volumetricWeight')

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BCard,
    BOverlay,
    BButton,
    BFormRadioGroup,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      loading: false,
      form: {
        enabled: false,
      },
      default_denominator: 5000,
      radioOptions: [
        { text: 'On', value: true },
        { text: 'Off', value: false },
      ],
    }
  },
  async mounted() {
    await this.readOrderSetting()
  },
  methods: {
    async readOrderSetting() {
      this.loading = true
      try {
        const { data } = (await VolumetricSettingsRepository.getVolumetricSetting()).data
        this.form = data
        if (localStorage.getItem('volumetric_setting') !== JSON.stringify(data)) localStorage.setItem('volumetric_setting', JSON.stringify(data))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async setVolumetricSetting() {
      this.loading = true
      try {
        const data = {
          enabled: this.form.enabled,
          default_denominator: this.default_denominator,
        }
        const res = await VolumetricSettingsRepository.setDefaultVolumetricSetting(data)
        if (res.status === 200) {
          this.showSuccessMessage('Volumetric Weight Settings Updated Successfully')
          localStorage.setItem('volumetric_setting', JSON.stringify(data))
        } else {
          this.showErrorMessage('Cannot Update Volumetric Weight Settings')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
  },
}
</script>
